export default {
  functionKey: "REGEXEXTRACT",
  title: "REGEXEXTRACT",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 3,
  requiredArguments: [
    { argumentKey: "Pattern", name: "Expression régulière" },
    { argumentKey: "Group",   name: "Numéro de groupe (0 = tout)", empty: true },
    { argumentKey: "Flags",   name: "Options (ex: i, g...)", empty: true }
  ],
  expectedArguments: [
    { name: "Expression régulière",          argumentKey: "Pattern", single: true, initialValue: "" },
    { name: "Numéro de groupe (0 = tout)",   argumentKey: "Group",   single: true, initialValue: "0", empty: true },
    { name: "Options (ex: i, g...)",         argumentKey: "Flags",   single: true, initialValue: "", empty: true }
  ],
  description: "Extrait la première correspondance d'une regex. (Ex: REGEXEXTRACT(valeur, '[0-9]+') -> '42')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const pattern = args[0] ?? "''";
    const group   = args[1] ?? "0";
    const flags   = args[2] ?? "''";
    const code = `{ const _m = ${origin}.match(new RegExp(${pattern}, ${flags})); ${destination} = _m ? (_m[${group}] ?? null) : null; }`;
    return { displayCode: code, safeCode: code };
  }
}
